function observeHiddenElements() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log(entry);
        if (entry.isIntersecting) {
          
          if (entry.target.classList.contains('hidden-sequential-bottom-left')) {
            entry.target.classList.add('show-sequential-bottom-left');
          }

          if (entry.target.classList.contains('hidden-sequential-bottom-right')) {
            entry.target.classList.add('show-sequential-bottom-right');
          }

          if (entry.target.classList.contains('hidden-sequential-top-right')) {
            entry.target.classList.add('show-sequential-top-right');
          }

          if (entry.target.classList.contains('hidden-sequential-top-left')) {
            entry.target.classList.add('show-sequential-top-left');
          }

          if (entry.target.classList.contains('hidden-animation-cards')) {
            entry.target.classList.add('show-cards');
          }
          if (entry.target.classList.contains('hidden-animation-slideshow')) {
            entry.target.classList.add('show-slideshow');
          }
          if (entry.target.classList.contains('animation-slideshow-button')) {
            entry.target.classList.add('show-slideshow-button');
          }
          if (entry.target.classList.contains('hidden-animation-slideshow-sub')) {
            entry.target.classList.add('show-slideshow-sub');
          }
          if (entry.target.classList.contains('hidden-animation-slideshow-sub-2')) {
            entry.target.classList.add('show-slideshow-sub-2');
          }
          if (entry.target.classList.contains('hidden-animation-testimonials')) {
            entry.target.classList.add('show-animation-testimonials');
          }
          if (entry.target.classList.contains('hidden-animation-overlapping-images')) {
            entry.target.classList.add('show-animation-overlapping-images');
          }
          if (entry.target.classList.contains('hidden-animation-to-top')) {
            entry.target.classList.add('show-cards-to-top');
          }
        } else {
          entry.target.classList.remove('show-sequential-bottom-left', 'show-sequential-bottom-right', 'show-sequential-top-right', 'show-sequential-top-left', 'show-slideshow', 'show-slideshow-sub', 'show-slideshow-sub-2', 'show-slideshow-button');
        }
      });
    });
    
    const hiddenElements = document.querySelectorAll('.hidden-sequential-bottom-left, .hidden-sequential-bottom-right, .hidden-sequential-top-right, .hidden-sequential-top-left, .hidden-animation-to-top, .hidden-animation-overlapping-images, .animation-slideshow-button, .hidden-animation-cards, .hidden-animation-slideshow, .hidden-animation-testimonials, .hidden-animation-slideshow-sub, .hidden-animation-slideshow-sub-2, .hidden-animation-slideshow-button');
    hiddenElements.forEach((el) => observer.observe(el));
  }

  window.addEventListener('DOMContentLoaded', (event) => {
    window.dispatchEvent(new Event('resize'));
    observeHiddenElements()
  });
  
  document.addEventListener("shopify:section:load", function(event) {
    window.dispatchEvent(new Event('resize'));
    observeHiddenElements()
  });